import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import React from 'react';

interface OutlineTooltipProps extends TooltipProps {
  width?: string;
}

export const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'rgb(248 248 248)',
    borderRadius: 6,
    height: 50,
    color: '#000',
    textTransform: 'uppercase',
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0.7,
  },
});

export const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#FFFFFF',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    padding: '16px',
    backgroundColor: '#FFFFFF',
    borderRadius: '4px',
    boxShadow: '0px 8px 12px 0px #292D3314',
    border: '1px solid #F7F7F7',
    placement: 'right',
  },
});

export const BlueTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    padding: '8px',
    backgroundColor: '#0E2467',
    lineHeight: '150%',
    color: 'white',
    borderRadius: '8px',
    boxShadow: '0px 6px 10px 0px rgba(41, 45, 51, 0.12)',
    // border: '1px solid #F7F7F7',
    fontSize: '14px',
  },
});

export const OutlineTooltip = styled(
  ({ className, ...props }: OutlineTooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ),
)(({ width }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    width: width ?? '240px',
    padding: '8px 12px',
    borderRadius: '8px',
    border: '1px solid var(--gray-150, #E7E8E8)',
    background: 'var(--white, #FFF)',
    boxShadow: '0px 4px 8px 0px rgba(41, 45, 51, 0.08)',
    color: 'var(--gray-900, #292D33)',
    fontFamily: 'Karla',
    fontSize: '14px',
    fontWeight: '400',
    maxWidth: '400px',
  },
}));

export const NoopTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    width: '0',
    padding: '0',
    borderRadius: '0',
    border: '0',
    background: 'transparent',
    boxShadow: 'none',
  },
});

export const DemographicTooltip = styled(
  ({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ),
)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#ffffff',
    maxWidth: 220,
    border: '1px solid #D6D8D9',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
    padding: '16px',
  },
}));
